// Stage 4 — propose a time, and respond to one via a magic link.
import { apiFetch } from '../lib/api';

// Send a standard-mode proposal to one connected person for a single slot.
// responder_base_url pins the magic-link back to THIS app (when.vennio.app) so
// the recipient stays in-channel — the API validates it against the first-party
// origin allowlist (Option 1). window.location.origin is the live host.
export async function sendProposal({ principalId, start, end, message = null }) {
  return apiFetch('/v1/proposals', {
    method: 'POST',
    body: {
      participant_ids: [principalId],
      slots: [{ start, end }],
      message,
      responder_base_url: window.location.origin,
    },
  });
}

// Public resolution of a magic-link token — no auth (the token IS the
// credential). Returns { proposal, originator, participant, token }.
export async function getProposalByToken(token) {
  return apiFetch(`/v1/proposals/by-token?token=${encodeURIComponent(token)}`, { auth: false });
}

// Respond to a proposal. If the clicker has a session, apiFetch attaches the
// JWT and the API acts as that user (token ignored); otherwise the token in the
// body authorises. Either path resolves to the bound participant.
export async function respondToProposal({ proposalId, token, action, selectedSlotId = null }) {
  const body = { token, action };
  if (action === 'accept' && selectedSlotId) body.selected_slot_id = selectedSlotId;
  return apiFetch(`/v1/proposals/${proposalId}/response`, { method: 'POST', body });
}
